import { BASE_URL_INTEGRATION, OTHER_BASE_URL_INTEGRATIONS } from 'app-constants';
import * as R from 'ramda';
import { UPDATE_BOTSPEC_PARSER_ERRORS } from '../namespace';

export const updateBotspecParsingErrors = (errors) => ({
  type: UPDATE_BOTSPEC_PARSER_ERRORS,
  payload: { errors },
});

const validateEntryPoint = (entrypoint) => (!entrypoint ? 'There is no entrypoint defined' : '');

export const validateSpec = (reteJson) => {
  const { entryPoint } = reteJson;
  const messages = [
    validateEntryPoint(entryPoint),
  ].filter((message) => message !== '');

  return messages;
};

export const updateIntegrationUrl = (specJson) => {
  const urlMappings = OTHER_BASE_URL_INTEGRATIONS.reduce(
    (mapping, url) => ({
      ...mapping,
      [new URL(url).hostname]: new URL(BASE_URL_INTEGRATION).hostname,
    }),
    {},
  );

  const updatedUrl = (rawUrl) => {
    const url = new URL(rawUrl);
    url.hostname = urlMappings[url.hostname] ?? url.hostname;
    return url.toJSON();
  };

  const updatedCallAPIAction = (action, rawUrl) => R.assocPath(['eval', 'url'], updatedUrl(rawUrl), action);
  const updatedActions = (actions) => Object.keys(actions).reduce(
    (newActions, key) => {
      const action = actions[key];
      const rawUrl = action.eval?.url;
      if (action.type === 'call_api' && URL.canParse(rawUrl)) {
        return {
          ...newActions,
          [key]: updatedCallAPIAction(action, rawUrl),
        };
      }
      return { ...newActions, [key]: actions[key] };
    },
    {},
  );

  // the URL of the integrations are only in the JSON spec actions
  return R.mergeDeepRight(specJson, {
    actions: updatedActions(specJson.actions),
  });
};
